import 'lightgallery.js';
import 'lightgallery.js/dist/css/lightgallery.min.css';

class ProductDetailExtension {

	constructor(naja) {
		naja.addEventListener('init', () => {
			this._initPhotoGallery(document);
			this._initTabScroll(document);
			this._initSwiper(document);
			this._initOptions(document);

			// isset anchor
			if (window.location.hash === '#bids_history' && document.getElementById('bids_history')) {
				let openElement = document.getElementById('bids_history');
				this._openTab(openElement);
			}
		});

		naja.snippetHandler.addEventListener('afterUpdate', (event) => {
			this._initPhotoGallery(event.snippet);
			this._initOptions(event.snippet);
		});
	}

	_initPhotoGallery(block) {
		const elemGallery = block.querySelector('.fn_lightgallery');
		const motherGallery = block.querySelector('.fn_mother-lightgallery');

		if (elemGallery) {
			lightGallery(elemGallery, {
				thumbnail: true,
				galleryId: 'gallery',
				selector: '.gallery'
			});
		}

		if (motherGallery) {
			lightGallery(motherGallery, {
				thumbnail: true,
				galleryId: 'gallery-2',
				selector: '.gallery-2'
			});
		}
	}

	_initTabScroll(block) {
		if (document.getElementById('fn_header')) {
			// let triggerElement = document.getElementById('fn_send-mess');
			// let targetTab = document.getElementById('question');
			block.querySelectorAll('[data-toggle="tab-scroll"]').forEach((triggerElement) => {
				let targetTab = block.querySelector(triggerElement.getAttribute('href'));

				if (targetTab) {
					triggerElement.addEventListener('click', (e) => {
						e.preventDefault();
						this._openTab(targetTab);
					});
				}
			});
		}
	}

	_initSwiper(block) {
		block.querySelectorAll('.fn_swiper-detail').forEach((swiperEl) => {
			new Swiper(swiperEl, {
				speed: 400,
				modules: [Pagination],
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				autoplay: {
					delay: 4000,
					disableOnInteraction: true,
				},
			});
		});
	}

	_initOptions(block) {
		block.querySelectorAll('[data-options-select]').forEach((select) => {
			select.addEventListener('change', (e) => {
				const option = document.querySelector('[value="' + e.target.value + '"]');
				if (option !== null) {
					naja.makeRequest('GET', option.getAttribute('data-ajax-href'));
				}
			});
		});
	}

	_openTab(targetTab) {
		const header = document.getElementById('fn_header') || document.querySelector('header');
		let headerHeight = header ? header.getBoundingClientRect().height : 0;

		// Zobrazení cílového tabu
		targetTab.classList.add('show');
		targetTab.classList.add('active');

		// Skrytí ostatních tabů
		let tabContents = document.querySelectorAll('.tab-pane');
		for (let i = 0; i < tabContents.length; i++) {
			if (tabContents[i] !== targetTab) {
				tabContents[i].classList.remove('show');
				tabContents[i].classList.remove('active');
			}
		}

		const tab = document.getElementById(targetTab.getAttribute('aria-labelledby'))
		tab.parentNode.parentNode.querySelectorAll('.nav-link').forEach(function (el) {
			el.classList.remove('active');
		});
		tab.classList.add('active');

		let targetTabOffsetTop;
		if (window.innerWidth >= 767) {
			targetTabOffsetTop = document.getElementById('productDetailTabList').offsetTop - headerHeight;
		} else {
			targetTabOffsetTop = document.getElementById('productDetailTabList').offsetTop;
		}

		window.scrollTo({
			top: targetTabOffsetTop,
			behavior: 'smooth'
		});
	}
}

naja.registerExtension(ProductDetailExtension);